"use client";

import { LocationOn } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import React from "react";
import { HorizontalBarChart } from "./HorizontalBarChart";
import { PieChartComponent } from "./PieChartComponent";
import { SectionCard } from "./SectionCard";
import { colors } from "./theme";

export interface LocationDistribution {
  location: string;
  count: number;
}

interface JobLocationDistributionChartProps {
  locationDistribution: LocationDistribution[];
}
const JobLocationDistributionChart: React.FC<JobLocationDistributionChartProps> = ({
  locationDistribution
}) => {
  // Map the location distribution data to the format expected by HorizontalBarChart.
  const chartData = locationDistribution.map((item, index) => ({
    skill: item.location,
    count: item.count,
    color: colors.chartColors[index % colors.chartColors.length]
  }));

  return (
    <SectionCard title="Job Location Distribution" icon={<LocationOn />}>
      {locationDistribution && locationDistribution.length > 0 ? (
        <HorizontalBarChart data={chartData} />
      ) : (
        <Typography align="center">
          No data available for Job Location Distribution.
        </Typography>
      )}
    </SectionCard>
  );
};

export default JobLocationDistributionChart;